<template>
  <v-container>
    <v-layout column class="text-center" md12>
        
      <v-flex class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">
          Datos
        </h1>
      </v-flex>

      <v-flex
        class="mb-4"
        cols="12"
        row
      >
        <v-flex justify="center">
          <div style="font-size: 25px;">
            Bienvenido {{usuario.nombre + ' ' + usuario.apellido}}
          </div>
        </v-flex>
      </v-flex>

      <v-flex
        class="mb-5"
        cols="12"
        row
      >
        <v-flex justify="center">
          <div style="font-size: 25px;">
            <v-text-field v-model="message" disabled label="URL para compartir:" id="textArea"/>
            <v-btn 
                style="background-color: #9D4593; color: white"
                v-clipboard:copy="message"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
            >
                Copiar URL para compartir
            </v-btn>
          </div>
        </v-flex>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import { EventBus } from '../../events.js'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
  export default {
    name: 'MainForm',

    data () {
      return {
        usuario: {},
        message: ''
      }
    },
    created () {
      if (this.$store.state.idCliente != '') {
        this.get_user(this.$store.state.idCliente)
      }
    },
    methods: {
      onCopy: function (e) {
          alert('Acabas de copiar el siguiente texto en el portapapeles: ' + e.text)
      },
      onError: function (e) {
          alert('No se pudo copiar el texto al portapapeles')
          console.log(e);
      },
      copyToClipBoard(data) {
        
      },
      get_user(id) {
        const here = this
        const db = firebase.firestore()
        db.collection('users').doc(id).get().then(function(doc) {
          const data = doc.data()
          if (data && data.clase && data.clase === 'demo') {
            here.usuario = data
            here.message = 'https://demosle.cl/home?id=' + here.usuario.idDemo
            console.log(here.usuario)
          }
        })
      }
    },
    mounted() {
        EventBus.$on('logedUser', data => {
            if (data) {
                this.get_user(this.$store.state.idCliente)
            }
        })
        if (this.$store.state.idCliente != '') {
          this.get_user(this.$store.state.idCliente)
        }
    }
  }
</script>